export function mark(name) {
  try { performance.mark(name); } catch { /* Diagnostics never block the app. */ }
}
export function measure(name, start) {
  try {
    if (performance.getEntriesByName(name).length > 100) performance.clearMeasures(name);
    performance.measure(name, start);
  } catch { /* The early bootstrap mark may be unavailable. */ }
}
export function observeImages() {
  try {
    const observer = new PerformanceObserver(list => {
      for (const entry of list.getEntries()) if (entry.initiatorType === 'img' || (entry.initiatorType === 'css' && /\.(?:jpe?g|png|webp|avif|gif|svg)(?:$|[?&#])/i.test(entry.name))) {
        measure('polka:image', { start: entry.startTime, duration: entry.duration });
      }
    });
    observer.observe({ type: 'resource', buffered: true });
    window.addEventListener('pagehide', () => observer.disconnect(), { once: true });
  } catch { /* Older WebViews still render images normally. */ }
}
